import * as React from "react";
const SvgCheckMarkThin = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 28 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 14L11.6 23.6L26 2", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheckMarkThin;
